<template>
	<div class="hdl-plan-selector">
		<div
			class="plan-choice free"
			@click.prevent="selectPlan('free')"
		>
			<font-awesome-icon
				:icon="(modelValue === 'free')? ['far', 'circle-dot'] : ['far', 'circle']"
				class="flex-none mr-2 radio"
			/>
			<div>
				<div class="name">Free</div>
			</div>
		</div>
		<div
			class="plan-choice pro"
			@click.prevent="selectPlan('pro')"
		>
			<font-awesome-icon
				:icon="(modelValue === 'pro')? ['far', 'circle-dot'] : ['far', 'circle']"
				class="flex-none mr-2 radio"
			/>
			<div>
				<div class="name mb-1">Pro ($24/month)</div>
				<div>
					5000 responses/month plus survey redirects, password protection, custom link previews, and more.
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircle, faCircleDot } from '@fortawesome/pro-regular-svg-icons';
import { Vue, Component, Prop } from 'vue-facing-decorator';

library.add(faCircleDot, faCircle);

@Component({
	emits: ['update:modelValue']
})
export default class PlanSelector extends Vue {
	@Prop({ default: null })
	modelValue: 'free' | 'pro';

	selectPlan(planKey: 'free' | 'pro'): void {
		this.$emit('update:modelValue', planKey);
	}
}
</script>

<style lang="scss">
.hdl-plan-selector {
	@apply border border-border-gray rounded;

	.plan-choice {
		@apply px-2 py-2 flex flex-row items-start hover:bg-fill-hover cursor-pointer;

		.radio {
			@apply text-lg mt-1 ml-2 mr-4 text-secondary;
		}

		&:not(:last-child) {
			@apply border-b border-border-gray;
		}

		.name {
			@apply font-semibold text-lg;
		}
	}
}
</style>
